module.exports = __webpack_public_path__ + "img/loading-square.8a815ced.gif";